import React from 'react';
import { Icon, type IconKind } from '../Icon/Icon';

export function PatientProfileChip({
  icon,
  accent,
  size = 28,
}: {
  icon: IconKind;
  accent: string;
  size?: number;
}) {
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center rounded-[9px]"
      style={{
        width: size,
        height: size,
        background: `color-mix(in srgb, ${accent} 14%, transparent)`,
        color: accent,
      }}
    >
      <Icon kind={icon} size={size * 0.5} stroke={1.9} />
    </span>
  );
}
